import  React, { useEffect, useState } from "react"; import Menubar from "../Menubar"; import { Nav, Container, Row, Col,Form,Tab,Tabs, Button,Modal} from "react-bootstrap"; import { store } from "../../App"; import {ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; import * as Yup from "yup";
import { MdOutlinePictureAsPdf } from "react-icons/md"; import "jspdf-autotable";
 import { exportToExcel, datetime, generatePdf, commonSelectProps, } from "../utils/commonFunctions";import { FaPlus, FaRegFile, FaRegFileAlt, FaSearch, FaEye } from "react-icons/fa";
   import Select from 'react-select'; 
import { Link } from "react-router-dom";
import AlertModal from "../Alert/AlertModal";import useAlert from "../Alert/useAlert";
import MasterService from "../../Services/MasterService";
import { FaRegSave } from "react-icons/fa";
import KpiService from "../../Services/KpiService";
import { RiUserFollowLine } from "react-icons/ri";

import { FaClipboardList, FaClock } from "react-icons/fa";import JoditEditor from "jodit-react";
import { useRef } from "react";
export default function Notificationlevelwise() {
 const editor = useRef(null);
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [data, setData] = useState([]); const [searchText, setSearch] = useState(""); const [Periodicid, setperiodicId] = useState(); const [Periodicitylist, setPeriodicitylist] = useState();const [Yearlist, setYearlist] = useState([]); const [Categorylist, setCategorylist] = useState(); const [mainEnb, setMainenb] = useState(false); const [mandalsName, setmandalsName] = useState(true); const [Deptname, setDeptname] = useState(); const [getEntered, setgetEntered] = useState(true);
  const[periodic, setperiodic] = useState(); const [selectedperiodicity, setselectedperiodicity] = useState(); const [enteredMandals, setEnteredMandals] = useState([]);const [notEnteredMandals, setNotEnteredMandals] = useState([]);
const[list,setList]=useState();let roleid = localStorage.getItem("role");

const [Years, setYears] = useState([]);
let username = localStorage.getItem("username"); 
const [Catlist, setCatlist] = useState([]);
const[seclist,setseclist]=useState([]);
  let deptId = localStorage.getItem("deptid");
  let secId = localStorage.getItem("sec_dept_id");
  let district = localStorage.getItem("districtid");let mandal = localStorage.getItem("mandalid")
  const [distEnb, setDistEnb] = useState(false);
     const [Deptlist, setDeptlist] = useState([]);
     const [distlist, setDistrictList] = useState([]);let ulbdeptlist=JSON.parse(localStorage.getItem("ulbdeptlist") || "[]"); const [mandallist, setMandalList] = useState(); 
     
       useEffect(() => { const handleScroll = () => { ReactTooltip.hide(); }; window.addEventListener("scroll", handleScroll); return () => { window.removeEventListener("scroll", handleScroll); }; }, []);
     

  const UlbDropDown =(params)=>{ KpiService.getulbList(params).then((response) => { if (response.data && response.data.SCODE === "01") { let options = response.data.SDESC.map((item, i) => {
     return ( <option key={item.ulb_code} value={item.ulb_code}> {item.ulb_name} </option> );
    
    }); 
  
  // setMandalList(options); 
        setMandalList([ { id: "0", value: "All" }, ...(response.data.SDESC || []).map((item) => ({ id: item.ulb_code, value: item.ulb_name, })), ]);
} }); }

        React.useEffect(() => {
           if ((roleid === "31" || roleid === "3") || (roleid === "10" || roleid === "32" || roleid === "2")) { setDistEnb(true) } if (roleid === "60" || roleid === "5") { setDistEnb(false) }
                formik.setFieldValue("district_id", district);

         }, [])
useEffect(() => {
  if (["60", "32", "31"].includes(roleid)) {
    formik.setFieldValue("deptId", deptId);
  }

MasterService.getDistricts().then((res17) => { if (res17.data) { let options = res17.data.map((item, i) => {
   return (<option key={item.id} value={item.id}> {item.value} </option>); });  }
        setDistrictList([ { id: "0", value: "All" }, ...(res17.data ?? []) ]);
  
  });

if(roleid==="32"){
if(ulbdeptlist.includes(deptId))
  { let params1 = { userId: username ,districtId: district }; UlbDropDown(params1); }
 else { 
 let params = { district_id: district };
    MasterService.getMandals(params).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
        // setMandalList(options);
        setMandalList([ { id: "0", value: "All" }, ...(res.data ?? []) ]); ;
  
      }
    });}
  }
let param = { userId: username};
  MasterService.getAllDepts(param).then((res) => { 
        if (res.data) { let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); }); 
        // setDeptlist(options);} })
        setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]); } });
}, []);



const formik = useFormik({
  initialValues: {
    department_id: "",
    dept_name: localStorage.getItem("deptcodeName") || "",
    district_id: "",type:"",
    mandal_id: "",
    title: "",
    description: "",
    document: null,
  },

  validationSchema: Yup.object({
  type: Yup.string().required("Type is required"),

    title: Yup.string().required("Subject Title is required"),
    description: Yup.string().required("Description is required"),
    // document: Yup.mixed()
    //   .required("Please upload a PDF file")
    //   .test(
    //     "fileFormat",
    //     "Only PDF files are allowed",
    //     (value) => !value || value.type === "application/pdf"
    //   ),
  }),

  onSubmit: (values) => {
    // const notificationData = {
    //   userId: username,
    //   subject: values.title,
    //   subjectDesc: values.description,
    //   notificationEntry: [
    //     {
    //   deptId: formik.values.department_id ,

    //       districtId: values.district_id,
    //       mandalId: ulbdeptlist.includes(formik.values.department_id)
    //         ? "0"
    //         : values.mandal_id||"0",
    //       ulbId: ulbdeptlist.includes(formik.values.department_id)
    //         ? values.mandal_id
    //         : "0",
    //     },
    //   ],
    // };
const isAllDept = formik.values.department_id === "0";

const notificationData = {
  userId: username,
  subject: values.title,
  subjectDesc: values.description,
  notificationEntry: [
    {
      deptId: isAllDept ? "9999" : formik.values.department_id,

      districtId: isAllDept
        ? "9999"
        : values.district_id === "0"
        ? "9999"
        : values.district_id||"0",

      mandalId: isAllDept
        ? "9999"
        : values.district_id === "0"
        ? "0"
        : ulbdeptlist.includes(formik.values.department_id)
        ? "0"
        : values.mandal_id === "0"
        ? "9999"
        : values.mandal_id||"0",

      ulbId: isAllDept
        ? "9999"
        : values.district_id === "0"
        ? "0"
        : ulbdeptlist.includes(formik.values.department_id)
        ? values.mandal_id === "0"
          ? "9999"
          : values.mandal_id||"0"
        : "0",
    },
  ],
};
    const formData = new FormData();

    formData.append(
      "notificationdata",
      JSON.stringify(notificationData)
    );

    if (values.document) {
      formData.append("file", values.document);
    }

    KpiService.saveNotification(formData)
      .then((response) => {
        console.log(response);

        if (response.data?.SCODE === "01") {
          showAlertMessage(
            response.data?.SDESC ||
              "Notification saved successfully",
            "success"
          );

          formik.resetForm();
          setFileKey(Date.now());
        } else {
          showAlertMessage(
            response.data?.SDESC ||
              "Failed to save notification",
            "warning"
          );
        }
      })
      .catch((error) => {
        console.error(error);
        showAlertMessage(
          "Failed to save notification",
          "warning"
        );
      });
  },
});




const downloadFile = async (fileName) => {
  try {
    const response = await MasterService.getGoPdf(fileName);

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const url = window.URL.createObjectURL(blob);

    // ✅ Open PDF in new tab
    window.open(url, "_blank");

    // Optional cleanup (after some delay)
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 1000);

  } catch (err) {
    console.error("Download failed:", err);
  }
};


const [fileKey, setFileKey] = useState(Date.now());



  const handleKeyDown = (e) => { if (e.key === 'Enter' || e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); } }


const [addModal,setAddModal] = useState(false);
 const[editenb,seteditenb] = useState(false); const[addModal1,setAddModal1] = useState(false);
const [showDescModal, setShowDescModal] = useState(false);

const mandalDropDown = (districtId) => {
  // if(roleid==="32"){
if(ulbdeptlist.includes(formik.values.department_id))
  { let params1 = { userId: username ,districtId: districtId }; UlbDropDown(params1); }
 else { 
 let params = { district_id: districtId };
    MasterService.getMandals(params).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
        // setMandalList(options);
        setMandalList([ { id: "0", value: "All" }, ...(res.data ?? []) ]); ;
  
      }
    });
  // }
  }
  
  }

    return (
        <>


                                <Menubar />
          <Container className='map-header1' fluid > <div className='sa-title'> <h2> Notification <span>  Level Wise </span></h2> </div> </Container>
      <Container fluid style={{ width: "87%" }} className="outer-page-content-container">
              <FormikProvider value={formik} >
                        <Form onSubmit={formik.handleSubmit}>
         
 <Row>


  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select mb-3">
                               <label className="mb-1 fw-bold">Type</label>

                               <Select
  {...commonSelectProps({
    name: "type",
    options: [
      { id: "HOD", value: "HOD" },
      { id: "District", value: "District" },
      { id: "Mandal", value: "Mandal" },
    ],
    value: formik.values.type,
    optionValueKey: "id",
    optionLabelKey: "value",
    formik,
    isDisabled:false,
    extraOnChange: (option) => {
      formik.setFieldValue("type", option ? option.id : "");
      formik.setFieldValue("district_id", "");
      formik.setFieldValue("mandal_id", "");
      formik.setFieldValue("department_id", "");
      setMandalList([]);
    }
  })}
/>
<ErrorMessage name="type"  className="text-error" component="div" />

</Col>
{["HOD", "District", "Mandal"].includes(formik.values.type) && (
             <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select mb-3">
                               <label className="mb-1 fw-bold">HOD Name</label>



    {["8", "5"].includes(roleid) ? ( 
    //   <Select {...commonSelectProps({ name: "department_id", options: Deptlist, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, 
    //                 isDisabled: ["32", "60", "31"].includes(roleid),extraOnChange: (option) => { formik.setFieldValue("department_id", option ? option.dept_id : "");
    //                    formik.setFieldValue("district_id", "");
    //   formik.setFieldValue("mandal_id", "");
    // }
                    
    //                   })} />

   <Select
  {...commonSelectProps({
    name: "department_id",
    options: Deptlist.filter((item) =>
      ["District", "Mandal"].includes(formik.values.type)
        ? item.dept_name !== "All" // or item.dept_id !== "0"
        : true
    ),
    value: formik.values.department_id,
    optionValueKey: "dept_id",
    optionLabelKey: "dept_name",
    formik,
    isDisabled: ["32", "60", "31"].includes(roleid),
    extraOnChange: (option) => {
      formik.setFieldValue(
        "department_id",
        option ? option.dept_id : ""
      );
      formik.setFieldValue("district_id", "");
      formik.setFieldValue("mandal_id", "");
    },
  })}
/>
                             ) : ( <Field className="mb-3 form-control" type="text" name="dept_name" value={localStorage.getItem("deptcodeName")} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }} /> )}
                             </Col>

)}
{[ "District","Mandal"].includes(formik.values.type) && (
             <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select mb-3'>
              <label className="mb-1 fw-bold">District</label> 

       {/* <Select {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled:distEnb, 
                extraOnChange: (option) => { mandalDropDown(option ? option.id : ""); formik.setFieldValue("district_id", option ? option.id : ""); formik.setFieldValue("mandal_id", ""); }    
                    })} /> */}
<Select
  {...commonSelectProps({
    name: "district_id",
    options:
      formik.values.type === "Mandal"
        ? distlist.filter((item) => item.id !== "0") // or item.id !== 0
        : distlist,
    value: formik.values.district_id,
    optionValueKey: "id",
    optionLabelKey: "value",
    formik,
    isDisabled: distEnb,
    extraOnChange: (option) => {
      mandalDropDown(option ? option.id : "");
      formik.setFieldValue("district_id", option ? option.id : "");
      formik.setFieldValue("mandal_id", "");
    },
  })}
/>

             </Col>                 

)}
{["Mandal"].includes(formik.values.type)  && (
  <>
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select mb-3">
      <label className="mb-1 fw-bold">
        {ulbdeptlist.includes(formik.values.department_id) ? "ULB" : "Mandal"}
      </label>

       <Select {...commonSelectProps({ name: "mandal_id", options: mandallist, value: formik.values.mandal_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled:distEnb, 
                    })} />

    
    </Col>
  </>
)}
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mb-3">
  <label className="fw-bold">Subject Title</label>
  <Field
    type="text"
    name="title"
    className="mb-6 form-control w-100" 
    rows={6} 
    style={{ minHeight: "54px" }}                          
  />

<ErrorMessage name="title"  className="text-error" component="div" />

  </Col>

  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mb-3">
  <label className="fw-bold">Description</label>
  <Field
    as="textarea"
    name="description"
    className="mb-6 form-control w-100" 
    rows={6} 
    style={{ minHeight: "54px" }}                          
  />

<ErrorMessage name="description"  className="text-error" component="div" />

  </Col>
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mb-3">

    <label className="fw-bold">Upload File</label>
    <input
      key={fileKey}
      type="file"
       name="document"
      accept=".pdf"
      className="mb-3 form-control"
      onChange={(e) =>
        formik.setFieldValue("document", e.target.files[0])
      }
    />
<ErrorMessage name="document"  className="text-error" component="div" />

  </Col>
    <Col md={3} >
          <div className="bottom-buttons mt-2 ">
                                                    <Button
                                                      variant=""
                                                      size="sm"
                                                      className="save-btn me-4"
                                                      type="submit"
                                                    >
                                                      Save <FaRegSave className="ms-1 s-icon" />
                                                    </Button></div>
  </Col>


              </Row>

   {/* <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                  <label className="mb-1 fw-bold"> District </label> <span style={{ color: "red" }}> *</span>
                  
                  <Select {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: distEnb, 
                    // extraOnChange: (option) => {  Oncngfun();getEntrydata(option? option.id:"",formik.values.department_id);Emptyfields(); } 
                    })} />
                 
                </Col> */}
{/* {roleid==="32" &&<>
                 <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                  <label className="mb-1 fw-bold"> Mandal </label> <span style={{ color: "red" }}> *</span>
                  
                  <Select {...commonSelectProps({ name: "mandal_id", options: mandallist, value: formik.values.mandal_id, optionValueKey: "id", optionLabelKey: "value", formik,  
                    // extraOnChange: (option) => {  Oncngfun();getEntrydata(option? option.id:"",formik.values.department_id);Emptyfields(); } 
                    })} />
                 
                </Col> */}

    

</Form> </FormikProvider> </Container> <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} /> </> ); }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            